export const ERROR_DEFAULT = "出错了！";

export const LIMIT = 10; // 默认 limit

export const OSS_ENDPOINT = "oss-cn-beijing.aliyuncs.com";
export const OSS_BUCKET = "links-comment";
export const DRIVER_LICENSE_PATH = "/comment";

export const OSS_LINK = "http://links-comment.oss-cn-beijing.aliyuncs.com";

export const MAX_UPLOAD_NUMBER = 4;

export const REGEXP = /\[.+?\]/g;

export const AVATAR = "";

export const IMAGE_SPLIT = "IMAGE_SPLIT";
